import en from './en-US';
import es from './es-ES';
import pt from './pt-BR';

const LANGUAGES = {
  ...en,
  ...es,
  ...pt
};

export default LANGUAGES;
